import { Link } from 'react-router-dom';

/**
 * Footer component - Modern Dark Design
 */
const Footer = () => (
  <footer className="footer bg-gray-900 text-gray-400 mt-auto">
    <div className="max-w-7xl mx-auto px-6 py-16">
      <div className="grid md:grid-cols-4 gap-12">
        {/* Brand Section */}
        <div className="md:col-span-2">
          <Link
            to="/"
            className="flex items-center gap-3 text-white text-xl font-semibold mb-4 hover:text-amber-400 transition-colors"
          >
            <img src="/logo.png" className="w-10 h-10 rounded-lg" alt="ಕನ್ನಡ ತಿಪಿಟಕ" />
            <span>ಕನ್ನಡ ತಿಪಿಟಕ</span>
          </Link>
          <p className="text-gray-400 max-w-md leading-relaxed">
            ಮಹಾ ಬೋಧಿ ಸೊಸೈಟಿ, ಬೆಂಗಳೂರು ಇಂದ ಪ್ರಸ್ತುತಪಡಿಸಿದ ಪಾಳಿ ತಿಪಿಟಕದ ಕನ್ನಡ ಅನುವಾದ.
          </p>
        </div>

        {/* Collections */}
        <div>
          <h4 className="text-white font-semibold mb-4">ಸಂಗ್ರಹಗಳು</h4>
          <ul className="space-y-3">
            <li>
              <Link to="/dn" className="text-gray-400 hover:text-white transition-colors">
                ದೀಘನಿಕಾಯ
              </Link>
            </li>
            <li>
              <Link to="/mn" className="text-gray-400 hover:text-white transition-colors">
                ಮಜ್ಝಿಮನಿಕಾಯ
              </Link>
            </li>
            <li>
              <Link to="/sn" className="text-gray-400 hover:text-white transition-colors">
                ಸಂಯುತ್ತನಿಕಾಯ
              </Link>
            </li>
          </ul>
        </div>

        {/* More Links */}
        <div>
          <h4 className="text-white font-semibold mb-4">ಇನ್ನಷ್ಟು</h4>
          <ul className="space-y-3">
            <li>
              <Link to="/books" className="text-gray-400 hover:text-white transition-colors">
                ಪುಸ್ತಕಗಳು
              </Link>
            </li>
            <li>
              <Link to="/locations" className="text-gray-400 hover:text-white transition-colors">
                ಬೋಧನಾ ಸ್ಥಳಗಳು
              </Link>
            </li>
            <li>
              <Link to="/contributors" className="text-gray-400 hover:text-white transition-colors">
                ಸಹಯೋಗಿಗಳು
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-sm text-gray-300">
          © {new Date().getFullYear()} ಬುದ್ಧ ವಚನ ಟ್ರಸ್ಟ್, ಮಹಾ ಬೋಧಿ ಸೊಸೈಟಿ
        </p>
        <div className="flex items-center gap-6 text-sm">
          <a
            href="#"
            onClick={e => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            className="text-gray-400 hover:text-white transition-colors"
          >
            ಮೇಲಕ್ಕೆ ↑
          </a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
